import Add from "./Add";
import List from "./List";

export default {
  Add,
  List
};
